<ion-row
  class="package-row"
  [tabindex]="0"
  [formGroup]="rowForm"
  (keyup)="keyboardPress($event)"
>
  <!-- Tracking Number -->
  <ion-col size="5" class="package-column">
    <label for="trackingNumber">
      {{ LABELS.TRACKING_NUMBER }}
    </label>

    @if (stopType === STOP_TYPE.DELIVERY) {
      <span class="required-field">*</span>
    }

    <ion-input
      formControlName="trackingNumber"
      class="form-control"
      maxlength="18"
      type="text"
      [ngClass]="{
        'required-input-field':
          rowForm.get('trackingNumber')?.invalid &&
          (rowForm.get('trackingNumber')?.dirty ||
            rowForm.get('trackingNumber')?.touched),
      }"
      [required]="stopType === STOP_TYPE.DELIVERY"
      [regexType]="REGEX"
      (paste)="commonUtils.sanitizePaste($event, 'alphanumeric')"
      (ionBlur)="checkTrackingNumber($event)"
    />

    <!-- Error messages for Tracking number -->
    @if (
      rowForm.get("trackingNumber")?.dirty ||
      rowForm.get("trackingNumber")?.touched
    ) {
      @if (rowForm.get("trackingNumber")?.hasError("invalidTrackingNo")) {
        <ion-text class="error-text">
          {{ ERROR_LABELS.BAD_TRACKING_NUMBER }}
        </ion-text>
      }

      @if (
        rowForm.get("trackingNumber")?.hasError("required") &&
        stopType === STOP_TYPE.DELIVERY
      ) {
        <ion-text class="error-text">
          {{ ERRORS.REQUIRED }}
        </ion-text>
      }

      <!-- Error for Intercepted package -->
      @if (rowForm.get("trackingNumber")?.hasError("intercepted")) {
        <ion-text class="error-text">
          {{ ERROR_LABELS.INTERCEPTED_TRACKING_NUMBER }}
          {{ rowForm.get("trackingNumber")?.value }}
          {{ ERROR_LABELS.RETURN_TO_CENTER }}
        </ion-text>
      }

      @if (rowForm.get("trackingNumber")?.hasError("duplicateTracking")) {
        <ion-text class="error-text">
          {{ CONSTANTS.VALIDATIONS.DUPLICATE_TRACKING_NUMBER }}
        </ion-text>
      }
    }
  </ion-col>

  <!-- Shipper Account -->
  <ion-col size="3" class="package-column">
    <label for="shipperAccount">
      {{ LABELS.SHIPPER_ACCOUNT }}
    </label>

    @if (
      rowForm.get("trackingNumber")?.value?.substring(0, 2) !== "1Z" &&
      rowForm.get("trackingNumber")?.value.length > 0 &&
      (rowForm.get("trackingNumber")?.dirty ||
        rowForm.get("trackingNumber")?.touched)
    ) {
      <span class="required-field">*</span>
    }

    <ion-input
      formControlName="shipperAccount"
      class="form-control"
      type="text"
      maxlength="6"
      minlength="6"
      [ngClass]="{
        'required-input-field':
          rowForm.get('shipperAccount')?.invalid &&
          (rowForm.get('shipperAccount')?.dirty ||
            rowForm.get('shipperAccount')?.touched),
      }"
      [regexType]="REGEX"
      [required]="
        (rowForm.get('trackingNumber')?.value?.substring(0, 2) !== '1Z' &&
          rowForm.get('trackingNumber')?.value.length > 0 &&
          (rowForm.get('trackingNumber')?.dirty ||
            rowForm.get('trackingNumber')?.touched)) ||
        false
      "
      (paste)="commonUtils.sanitizePaste($event, 'alphanumeric')"
    />

    @if (
      rowForm.get("shipperAccount")?.dirty ||
      rowForm.get("shipperAccount")?.touched
    ) {
      @if (rowForm.get("shipperAccount")?.hasError("required")) {
        <ion-text class="error-text">
          {{ ERRORS.REQUIRED }}
        </ion-text>
      }

      @if (rowForm.get("shipperAccount")?.hasError("minlength")) {
        <ion-text class="error-text">
          {{ LABELS.INVALID_SHIPPER }}
        </ion-text>
      }
    }
  </ion-col>

  @if (stopType == STOP_TYPE.DELIVERY) {
    <ion-col size="2" class="package-column">
      <label for="cod">
        {{ LABELS.COD }}
      </label>

      @if (hasCodValidator) {
        <span class="required-field">*</span>
      }

      <ion-input
        [attr.name]="'cod'"
        formControlName="cod"
        class="form-control"
        type="text"
        maxlength="11"
        [ngClass]="{
          'required-input-field':
            rowForm.get('cod')?.invalid &&
            (rowForm.get('cod')?.dirty || rowForm.get('cod')?.touched),
        }"
        (keypress)="preventMaxLimitValue($event)"
      ></ion-input>

      <!-- Error for COD required -->
      @if (
        rowForm.get("cod")?.hasError("required") &&
        rowForm.get("cod")?.touched &&
        stopType === STOP_TYPE.DELIVERY
      ) {
        <ion-text class="error-text">
          {{ ERROR_LABELS.REQUIRED_COD }}
        </ion-text>
      }

      <!-- Error message for COD -->
      @if (rowForm.get("cod")?.hasError("codAmountInvalid")) {
        <ion-text class="error-text cod-error">
          {{ ERROR_LABELS.COD_GREATER_THAN_ZERO }}
        </ion-text>
      }
    </ion-col>
  } @else {
    <ion-col size="2" class="package-column">
      <label for="declaredValue">
        {{ LABELS.DECLARED_VALUE }}
      </label>
      <ion-input
        [attr.name]="'declaredValue'"
        formControlName="declaredValue"
        class="form-control"
        type="text"
        maxlength="11"
        (keypress)="preventMaxLimitValue($event)"
      ></ion-input>
    </ion-col>
  }

  @if (index === 0) {
    <ion-col size="1" class="package-column">
      <img
        class="package-button"
        [src]="IMAGES.DELETE"
        [alt]="LABELS.REMOVE_PACKAGE"
        (click)="removeClick()"
      />
    </ion-col>
    <ion-col size="1" class="package-column">
      <img
        class="package-button"
        [src]="IMAGES.ADD_CIRCLE_BLUE"
        [alt]="LABELS.ADD_PACKAGE"
        (click)="addClick()"
      />
    </ion-col>
  } @else {
    <ion-col size="2" class="package-column">
      <img
        class="package-button"
        [src]="IMAGES.DELETE"
        [alt]="LABELS.REMOVE_PACKAGE"
        (click)="removeClick()"
      />
    </ion-col>
  }
</ion-row>
